import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const usePregnancyConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options = [
    defaultSortingOption,
    {
      value: 'created',
      label: t('pregnancy.sorting_options.registration_date_asc')
    },
    {
      value: '-created',
      label: t('pregnancy.sorting_options.registration_date_desc')
    },
    {
      value: 'lastMenstrualPeriod',
      label: t('pregnancy.sorting_options.last_gestation_date_asc')
    },
    {
      value: '-lastMenstrualPeriod',
      label: t('pregnancy.sorting_options.last_gestation_date_desc')
    },
    {
      value: 'gestationalAgeInWeeks',
      label: t('pregnancy.sorting_options.gestational_age_in_weeks_asc')
    },
    {
      value: '-gestationalAgeInWeeks',
      label: t('pregnancy.sorting_options.gestational_age_in_weeks_desc')
    },
    {
      value: 'pregnancyTypeId',
      label: t('pregnancy.sorting_options.pregnancy_type_asc')
    },
    {
      value: '-pregnancyTypeId',
      label: t('pregnancy.sorting_options.pregnancy_type_desc')
    },
    {
      value: 'expectedDateOfBirth',
      label: t('pregnancy.sorting_options.expected_date_of_birth_asc')
    },
    {
      value: '-expectedDateOfBirth',
      label: t('pregnancy.sorting_options.expected_date_of_birth_desc')
    }
  ]

  return { options }
}
